import { IconSizes } from '@inno-ui/icons'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'

import { getPackageDetailsData } from './PackageDetailsCard.constant'
import styles from './PackageDetailsCard.module.scss'

export const PackageDetailsCard = () => {
  const { t } = useTranslation('auth', {
    keyPrefix: 'package_details.card'
  })
  const packageData = getPackageDetailsData(t)

  return (
    <div className={styles.packageDetailsCard}>
      <h2 className={styles.title}>{packageData.title}</h2>
      <ul className={styles.featuresList}>
        {packageData.features.map((feature, index) => {
          const Icon = feature.icon
          return (
            <li key={index} className={styles.featureItem}>
              <Icon
                size={IconSizes.Size20}
                color='var(--white)'
                className={styles.featureIcon}
              />
              <span
                className={cn(styles.featureText, {
                  [styles.bold]: feature.isBold
                })}
              >
                {feature.text}
              </span>
            </li>
          )
        })}
      </ul>
      <div className={styles.pricing}>
        <span className={styles.price}>{packageData.pricing.price}</span>
        <span className={styles.duration}>{packageData.pricing.duration}</span>
      </div>
    </div>
  )
}
